import HttpService from './http-service';
import EdudoResponse from '../models/edudo-response';

export default class NoticeBoardService {
  async listNoticeBoards(): Promise<NoticeBoardGroup[]> {
    const response = await HttpService.getJson<EdudoResponse<NoticeBoardGroup[]>>(
      '/v1/noticeBoards/list'
    );

    return response.data;
  }

  async getNoticeBoard(
    noticeBoardId: string
  ): Promise<NoticeBoardCreated> {
    const response = await HttpService.getJson<
      EdudoResponse<NoticeBoardCreated>
    >(
      `/v1/noticeBoards/${noticeBoardId}`
    );

    return response.data;
  }

  deleteNoticeBoard(noticeBoardId: string) {
    return HttpService.delete(`/v1/noticeBoards/${noticeBoardId}`);
  }


  async createNoticeBoard(data: NoticeBoardFormData) {
    const formatedData: NoticeBoardUpdated = {
      noticeBoardItem: {
        title: data.formData.title,
        imageId: data.formData.imageId,
        attachment: data.formData.attachment,
      },
      classroomIds: data.classData,
    };

    return HttpService.postJson(`/v1/noticeBoards/`, formatedData);
  }

  updateNoticeBoard(data: NoticeBoardFormData, id: string) {
    const formatedData: NoticeBoardUpdated = {
      noticeBoardItem: {
        title: data.formData.title,
        imageId: data.formData.imageId,
        attachment: data.formData.attachment,
      },
      classroomIds: data.classData,
    };

    return HttpService.putJson(`/v1/noticeBoards/${id}`, formatedData);
  }
}
